import React, { useEffect, useState } from "react";
import NavHeader from "../components/NavHeader";
import {
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack,
  useToast,
} from "@chakra-ui/react";
import cr from "../lib/request";
import { Course } from "../const/types";
import ComponentSpinner from "../components/ComponentSpinner";
import useTrigger from "../globalState/useTrigger";
import NoData from "../components/NoData";
import TableContainer from "../components/TableContainer";
import { MagnifyingGlass } from "@phosphor-icons/react";
import NoOflinesText from "../components/NoOflinesText";
import formatDate from "../lib/formatDate";
import RestoreCourseModal from "../components/courseComponents/RestoreCourseModal";

export default function CourseRestore() {
  const [search, setSearch] = useState<string>("");
  const [data, setData] = useState<Course[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger } = useTrigger();

  useEffect(() => {
    setLoading(true);
    const url = `api/course/getalldeletedpost`;

    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: e.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [trigger, toast]);

  return (
    <>
      <NavHeader la={"back"} label="Restore Course" />

      {!loading && data && data.length > 0 ? (
        <VStack align={"stretch"}>
          <VStack p={5}>
            <InputGroup>
              <InputLeftElement>
                <Icon as={MagnifyingGlass} />
              </InputLeftElement>
              <Input
                placeholder="Pencarian"
                maxW={"400px"}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                value={search}
              />
            </InputGroup>
          </VStack>

          <TableContainer>
            <Table>
              <Thead>
                <Tr>
                  <Th pl={5}>#</Th>
                  {/* <Th>ID</Th> */}
                  <Th></Th>
                  <Th>Judul</Th>
                  <Th>Kategori</Th>
                  <Th>Dihapus</Th>
                  <Th pr={5} textAlign={"center"} w={"100px"}>
                    Aksi
                  </Th>
                </Tr>
              </Thead>

              <Tbody>
                {data.map((course, i) => {
                  const ok =
                    course.nama_course
                      .toLowerCase()
                      .includes(search.toLowerCase()) ||
                    course.id.toString().includes(search);

                  return (
                    ok && (
                      <Tr
                        key={i}
                        _hover={{ bg: "var(--divider)" }}
                        transition={"200ms"}
                      >
                        <Td pl={5} opacity={0.5}>
                          {i + 1}
                        </Td>
                        {/* <Td>{course.id}</Td> */}
                        <Td>
                          <VStack w={"80px"}>
                            <Image
                              h={"50px"}
                              w={"80px"}
                              objectFit={"cover"}
                              src={`${process.env.REACT_APP_MEDIA_BASE_URL}${course.image}`}
                            />
                          </VStack>
                        </Td>
                        <Td>
                          <NoOflinesText w={"200px"}>
                            {course.nama_course}
                          </NoOflinesText>
                        </Td>
                        <Td whiteSpace={"nowrap"}>{course.theme.theme_name}</Td>
                        <Td whiteSpace={"nowrap"}>
                          {formatDate(course.deleted_at)}
                        </Td>
                        <Td pr={5}>
                          <RestoreCourseModal data={course} />
                        </Td>
                      </Tr>
                    )
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </VStack>
      ) : !loading && data && data.length === 0 ? (
        <NoData />
      ) : (
        <ComponentSpinner flex={1} />
      )}
    </>
  );
}
